import { IAsessProductFormData, IDocumentApprovalFormData, IPrePanelInformationFormData, IPannelReviewFormData, IVendorInformationFormData, INewVendorFormData, IStorageFormData, IVendorAssessmentFormData, IIngredientDetailsFormData, IVendorContactInformationFormData, IPurchaseOrderInformationFormData, IManufacturingFacilityInformationFormData, ITastingPanelFormData, IProductInformationFormData, IdeaData, SelectedIdea, Statuses, ButtonToVisible, IRequiredDocumentData, IMVADocumentResponse, VendorAssessmentButtonToVisible, vendorStatuses, ICertificatesDocumentsVendorInfoFormData, IAddNewVendorUserData, TransitionObject, VendorPrePanelInformationFormData, IVendorSetupFormData, IOfficialProductSetupFormData, vendorStatusesObj, PrePanelButtonToVisible, IVendorSiteDetailsFormData, BusinessReviewButtonToVisible, IVendorAuditDetailsFormData, TastingPanelVendorStatusesObj, TastingPanelButtonToVisible, IAddNewVendorUserFormData, VendorSiteDetailsFormData, FoodSafetyQuestionnaireFormData, ISendWelcomeEmailFormData, IVendorUser, APComplianceDocumentsButtonToVisible, APMainDetailsButtonToVisible, APPackagingButtonToVisible, APRecipeButtonToVisible, APRawMaterialsButtonToVisible, APAllergensButtonToVisible, APNutritionButtonToVisible, APNutritionDeclarationButtonToVisible, APStorageButtonToVisible, VendorContactData } from "@/context/data.types";
import { convertToUTCAndFormat } from "@/utils/helper";

// External library imports
import { format, startOfDay } from 'date-fns';

export const PannelReviewFormData: IPannelReviewFormData = {
  name: "Goat Cheese and Fig Ravioli",
  subItems: "",
  panelType: "Wednesday Panel",
  businessReviewDate: "2024-06-19",
  itemStatus: "Need More Info for Business Review",
  starBusinessReviewQuestionnairetedOn: "",
  businessReviewQuestionnaireStatus: "CM Submitted",
  reviewNotes: "Confirm with Nutrition that it can be called Goat Cheese",
  bostonPanelDate: "2024-06-26",
  bostonPanelNotes: "underwhelming presentation, but excellent flavor",
  voteResultsBoston: "",
  itemID: "6684556071",
}

export const AsessProductFormData: IAsessProductFormData = {
  workingProductName: "Product A",
  category: "Snacks",
  periodOfAvailability: "Every Day",
  regionsOfAvailability: "North America",
  countryOfOrigin: "USA",
  weight: "200g",
  packaging: "Plastic bag",
  sustainabilityNotes: "Recyclable packaging",
  retailPrice: "4.99",
  compInfo: "Competitor A: $5.99",
  vendorName: "Vendor A",
  vendorInfo: "Existing, #12345",
  existingProducts: "Product B, Product C",
  productProfile: "Golden, round, crisp, sweet",
  verifiableAttributes: "Kosher, Gluten Free",
  usesSuggestions: "Great as a snack or topping for salads",
  productStory: "Unique flavor profile and high demand",
  thing1: "Made with organic ingredients",
  thing2: "Innovative packaging",
  thing3: "Affordable price point",
  sku: "SKU12345",
  skuDescription: "Product A Description",
  avgWeeklySalesUnits: "100",
  avgWeeklySalesDollars: "499",
  retail: "Retail Info",
  productWeight: "200g",
  nutritionFacts: "Calories: 200",
  ingredients: "Almonds, Sugar, Salt",
};
export const PanelProductInformationFormData: IPrePanelInformationFormData = {
  productInformation: "Click to Product information",
  vendorInformation: "Click to Vendor Information",
  category: "Snacks",
  categoryManager: "Jamie Rolfe",
  developer: "John Doe",
  priority: "high",
  cost: ".96 FOB",
  retailPrice: "1.69-99",
  freightCost: 2024,
  size: "Medium",
  packSize: 24,
  totalCost: 77,
  containerQuantity: 50,
  launchDate: new Date("07-01-2024"),
  reviewDate: new Date("08-25-2024"),
  deadlineProvided: new Date("06-01-2024"),
  productInfoSheet: "Click to Product information sheet",
  productSpecSheet: "Click to Product specification sheet",
  sampleRequested: "yes",
}

export const DocumentApprovalFormData: IDocumentApprovalFormData = {
  productCreator: "John Doe",
  categoryManager: "Jane Doe",
  workingNameOfProduct: "Product A",
  inspiration: "Inspiration for Product A",
  vendorPartnerReason: "Reason for partnering with Vendor A",
  isFacilityVisitedWithDate: "2024-06-19",
  isEstimatedWeeklyVolumeConfirmed: "Yes",
  isVendorProducingSimilarProduct: "Yes",
  isVendorSellingSimilarProductInUS: "Yes",
  valueAdditionAndNeed: "Value addition and need for Product A",
  thoughtsOnVendor: "Thoughts on Vendor A",

}

export const VendorInformationFormData: IVendorInformationFormData = {
  vendorCorporateName: "",
  vendorFirstName: "",
  vendorLastName: "",
  vendorEmailAddress: "",
  vendorCorporateAddress: "",
  vendorCity: "",
  vendorState: "",
  vendorCountry: "",
  vendorZipCode: "",
  subStatus: "",
  logistics: "",
  retailStructure: "",
  tariff: "",
  multipack: {
    id: "",
    giftPack: null,
    amountOfProductsInGiftPack: null,
    sharedForReview: false
  }
}

export const DefaultVendorInformationList: IVendorInformationFormData[] = [{
  vendorCorporateName: "",
  vendorFirstName: "",
  vendorLastName: "",
  vendorEmailAddress: "",
  vendorCorporateAddress: "",
  vendorCity: "",
  vendorState: "",
  vendorCountry: "",
  vendorZipCode: "",
  logistics: "",
  retailStructure: "",
  tariff: "",
  multipack: {
    id: "",
    giftPack: null,
    amountOfProductsInGiftPack: null,
    sharedForReview: false
  }
}]

export const NewProductInformationFormData: IProductInformationFormData = {
  title: "",
  description: "",
  addedOn: convertToUTCAndFormat(new Date()),
  requiredAttributes: "",
  reasonForDevelopment: "",
  diversificationSku: "",
  estWeeklySales: undefined,
  estWeeklyUnitVol: undefined,
  potentialSupplier: "",
  notes: "",
  categoryManagerUserId: undefined,
  developer: "",
  launchDate: "",
  retailPrice: undefined,
  size: "",
  packSize: undefined,
  containerQuantity: undefined,
  productSpecificationType: "",
  opportunityBuy: "",
  oppBuyIndicator: "",
  buyer: "",
  businessCategory: undefined,
  productType: undefined,
  sellingPeriod: undefined,
  pathConcatenated: "",
  businessCategoryIdsConcatenated: "",
  subStatus:"",
};

export const DefaultStatusesOfProduct: Statuses = {
  status: "Not started",
  subStatus: "Draft",
  workflowStatus: "Active",
  taskId: "",
  workflowTransitions:[]
}

export const  DefaultButtonVisibility: ButtonToVisible = {
  showSave: false,
  showHold: false,
  showCancel: false,
  showSFR: false,
  showReactivate: false,
  showRFR: false,
  showRC: false,
  showDelete: false,
  showSFRed: false,
  showInitiateVendorTasks: false,
  showRCed: false,
  showPVA:false,
  showPedVA:false
}
export const DefaultVendorAssessmentButtonVisibility: VendorAssessmentButtonToVisible = {
  showPcSave: false,
  showVendorSave: true,
  showCancel: false,
  showReactivate: false,
  showDelete: false,
  showInitiateVendorTasks: false,
  showInitiatedVendorTasks: false,
  showReviewComplete: false,
  showReviewCompleted: false,
  showRequestForRevision: false,
  showShareForReview: false,
  showSharedForReview: false,
  showRequestedForRevision: false,
  showRequestForNfpDocument: false,
  showSubmitNfpDocument: false,
}
export const DefaultPrePanelButtonVisibility: PrePanelButtonToVisible= {    
  showSave: false,
  showNext: false,
  showSFR: false,
  showRC: false,
  showDelete: true,
  showSFRed: false,
  showRCed: false,
}
export const DefaultBusinessReviewButtonVisibility: BusinessReviewButtonToVisible= {  
  showSave: true, // Default to showing Save button
  showSFR: false,  
  showSFBR: false,
  showSFRed: false,
  showSFBRed: false,
  showArchive: false,
  showReactivate: false,
  showDelete: false,
  showMIN: false, //More Information Needed
  showRFTP: false, //ready for tasting panel
  showHold: false,
  showSFRP: false, //Send for Re-Panel
  showReactivateIdea: false
}
export const DefaultTastingPanelButtonVisibility: TastingPanelButtonToVisible = {  
  showSave: true, // Default to showing Save button
  showSFTPR: false,  // Share for tasting panel review
  showSFTPRAfterRevision: false, // Share for tasting panel review after revision
  showArchive: false,
  showApprove: false,
  showRFR: false, // Request for revision
  showReactivate: false,
  showDelete: false,
  showRequestForNfpDocument: false,
}
export const DefaultAPComplianceDocumentsButtonVisibility: APComplianceDocumentsButtonToVisible = {  
  showShareForReview: false,
  showSave: false,
  showNext: true,
  showRequestForRevision: false,
  showReviewComplete: false,
}
export const DefaultAPMainDetailsButtonVisibility: APMainDetailsButtonToVisible = {  
  showSave: true,
  showShareForReview: false,
  showNext: true,
  showRequestForRevision: false,
  showReviewComplete: false,
}
export const DefaultAPPackagingButtonVisibility: APPackagingButtonToVisible = {  
  showShareForReview: false,
  showSave: true,
  showRequestForRevision: false,
  showRC: false,
}
export const DefaultAPRecipeButtonVisibility: APRecipeButtonToVisible = {  
  showSave: true,
  showRequestForRevision: false,
  showRC: false,
}
export const DefaultAPRawMaterialsButtonVisibility: APRawMaterialsButtonToVisible = {  
  showSave: true,
  showRequestForRevision: false,
  showRC: false,
}
export const DefaultAPAllergensButtonVisibility: APAllergensButtonToVisible = {  
  showSave: true,
  showRequestForRevision: false,
  showRC: false
}
export const DefaultAPNutritionButtonVisibility: APNutritionButtonToVisible = {  
  showSave: true,
  showRequestForRevision: false,
  showRC: false
}
export const DefaultAPNutritionDeclarationButtonVisibility: APNutritionDeclarationButtonToVisible = {  
  showSave: true
}
export const DefaultAPStorageButtonVisibility: APStorageButtonToVisible = {  
  showSave: true,
  showRequestForRevision: false,
  showRC: false,
}
export const SelectedIdeaInfo: SelectedIdea = {
  ideaName: ""
};
export const ProductIdeaData: IdeaData = {
  id: "",
  title: "",
  description: "",
  addedOn: "",
  requiredAttributes: [],
  reasonForDevelopment: "",
  diversificationSku: "",
  estWeeklySales: null,
  estWeeklyUnitVol: null,
  potentialSupplier: "",
  notes: "",
  categoryManagerUser: "",
  developer: "",
  launchDate: "",
  retailPrice: undefined,
  size: "",
  packSize: undefined,
  containerQuantity: null,
  businessCategoryIdsConcatenated: null,
  subStatus: "",
  businessCategory: {
    id: "",
    categoryId: "",
    description: "",
    categoryType: "",
    leader: ""
  },
  productType: "",
  sellingPeriod: "",
  product: null,
  ideaGroups: [],
  vendors: null,
  comments: [],
  similarProductsCollection: null,
  competitiveProductsCollection: null,
  businessStatus: "",
  newWorkflowStatus: "",
  availableTransitions: {
    objectId: "",
    portalUserId: "",
    transitions: {
      data: []
    }
  },
  productSpecificationType: null,
  workflowStateCreateNewIdea: "Not Started",
  workflowStateIdeaOnhold: ""
};

export const NewVendorDetailsForm: INewVendorFormData = {
  vendorName: "",
  itemDescription: "",
  vendorContactInformation: "",
  retailPrice: "",
  dateForGreenLightToOrder: "",
  size: "",
  packSize: "",
  containerQuantity: "",
  launchDate: "",
  deadlineProvided: "",
  dateApproved: "",
  sampleRequested: "No",
  sku: "",
  products: [
    {
      productName: "",
      productDescription: "",
      weightVolumePackQtyEach: "",
      skuNumber: "",
      categoryManager: "",
      siteName: "",
      businessCategories: "",
      status: "Active",
      vendorCode: "",
      siteCode: "",
      kosher: "No",
      organic: "No",
      tjsVendorNumber: "",
    }
  ],
}

export const StorageFormData: IStorageFormData = {
  productSpecificationName: "Cookie ginger orange cardamom",
  specificationNumber: 1234,
  version: 1,
  status: "Suppier draft",
  vendorName: "Daisy chain cookies",
  specificationType: "Food & Beverages, Pet Food & Dietary Supplements (TJ’s and Exclusive/Controlled Branded Labels)",

  // Storage details
  primaryShelfLifeCodingFromDateOf: "Manufacture",
  period: "",
  formatOfShelfLifeCoding: "",
  traderJoesDistributionChain: "Temp control(year round)",

  // Pack coding
  primaryShelfLife: "Best Before",
  primaryShelfLifeNumber: 720,
  primaryShelfLifeOuterCase: true,
  secondaryShelfLife: "Best Before",
  secondaryShelfLifeNumber: 720,
  secondaryShelfLifeOuterCase: true,
  comments: "",

  // Attachments
  section: "Product record ",
  filenameOrURL: "Montary-jack-rumanio.docx", //auto populated
  description: "Ingredient statement",
  bytes: 0, //auto populated
  attachedBy: "Carol", //auto populated
  attachedOn: "2024-07-25", //auto populated
};

export const packProductFormData = {
  // Storage Details Section
  primaryShelfLifeCodingFromDateOf: "",
  period: "",
  formatOfShelfLifeCoding: "",
  bestByDateImprintRequired: "",
  
  // Pack Coding Section - Array with one initial entry
  packCodingEntries: [{
    primaryShelfLife: "",
    primaryNumber: null,
    primaryOuterCase: "",
    secondaryShelfLife: "",
    secondaryNumber: null,
    secondaryOuterCase: "",
    comments: "",
    minimumShelfLifeInfo: "",
    days: null,
    defineEntireLotCodeInformation: "",
  }],
  
  // Shelf Life Coding Statement Section - Array with one initial entry
  shelfLifeCodingStatementEntries: [{
    statement: "",
    useOnPack: "",
  }],
  
  // Documents Section - Empty array, will be populated from API or user uploads
  attachments: [],
  
  // Individual properties (required by IPackProductFormData interface)
  primaryShelfLife: "",
  primaryNumber: null,
  primaryOuterCase: false,
  secondaryShelfLife: "",
  secondaryNumber: null,
  secondaryOuterCase: false,
  comments: "",
  minimumShelfLifeInfo: "",
  days: null,
  defineEntireLotCodeInformation: "",
}

export const PackagingFormData = {

  // packaging
  productSpecificationName: "Cookie ginger orange cardamom",
  specificationNumber: 1234,
  version: 1,
  status: "Suppier draft",
  vendorName: "Daisy chain cookies",
  specificationType: "Food & Beverages, Pet Food & Dietary Supplements (TJ’s and Exclusive/Controlled Branded Labels)",

  // packagingComponent 
  packagingDescription: "90G × 24/CTN",
  packagingComponentName: "Lid",
  level: "Primary(Food Contract)",
  foodContact: "yes",
  specificationDefiningCharacteristics: "",
  // weightOfComponent: 7.6,
  recycledContent: 20,
  doesThisComponentContainBPA: "No",
  weightOfRecycled: 3,
  packagingSupplier: "HAKUYO GLASS Co., Ltd.",
  countryOfOrigin: "Japan",
  dimensions: "",
  material: "Steel",

  // recyclingIcons
  text: "22-PAP-Paper",
  supportingText: "",
  usedOnPack: "Do Not Use on Pack",

  // attachments
  section: "Product record",
  download: "",
  filenameOrURL: "Montary-jack-rumanio.docx",
  description: "Ingredient statement",

  newAttachments: [{
    newFileName: "",
    newDescription: ""
  }]
}

// Packaging component
export const VendorAssessmentFormData: IVendorAssessmentFormData = {
  vendorName: "",
  productDeveloper: "",
  productName: "",
  typeOfVendor: "",
  addedOn: convertToUTCAndFormat(new Date()),
  currentlyManufactureSameSimilarProduct: "",
  mostSimilarProduct: "",
  experienceWithSimilarType: "",
  countryOfOrigin: "",
  prop65Warning: "",
  privateLabelFosUsCompanies: "",
  capacityProductionRun: "",
  capacityProductionLines: "",
  capacityFacilities: "",
  outsourceProduction: "",
  sameTypeOfProductUnderConsideration: "",
  facilityGfsiCertified: "",
  certificationWithdrawnWithinLast5Years: "",
  testFinishedProductsForPathogens: "",
  metalDetectionXrayOnProductLine: "",
  otherMetalDetectionXrayOnProductLine: "",
  haccpFspPlan: "",
  allergenManagementProgram: "",
  productRecallProcedure: "",
  recallWithinLast5Years: "",
  recallDetail: "",
  facilityFdaUsdaInspected: "",
  usdaPlantNo: "",
  regulatoryEnforcementAction: "",
  adulteratedProductPoliciesProcedures: "",
  importAutomaticDetention: "",
  outsourceDescripton: "",
  factor: "",
  childLaborVendor: "",
  animalWelfareFraud: "",
  fsma: "",
  edi: "",
  canTrackLotCodes: "",
  manufacturingFacilityLocations: ""
}

export const IngredientDetailsFormData: IIngredientDetailsFormData = {
  vendorName: "",
  ingredientList: [],
  subIngredientList: "",
  unacceptableIngredients: "",
  acceptableIngredients: "",
  ingredientNotFoundList: "",
  ingredientCompliance: null,
  Comments: "",
  productspecifications: [],
}



export const PurchaseOrderInformationFormData: IPurchaseOrderInformationFormData = {
  contactPersonForPurchaseOrder: "",
  purchaseOrderContactPhone: "",
  purchaseOrderContactEmail: "",
  remittanceAddress: "",
  remittanceCityStateZipCountry: "",
  desiredPaymentTerms: "",
  federalTaxID: "",
  hasMoreThanOneSite: "",
}

export const TastingPanelFormData: ITastingPanelFormData = {
  name: '',
  panelType: '',
  reviewNotes: '',
  category: '',
  reasonForDevelopment: '',
  diversificationReplacementSKU: '',
  businessNeedProductStory: '',
  productType: '',
  sellingPeriod: '',
  producer: '',
  specialConsiderations: '',
  developerPresenter: '',
  categoryManager: '',
  panelDate: null,
  estimatedWeeklySales: '',
  estimatedWeeklyVolume: '',
  proposedRetail: '',
  compRetail: '',
  retailStructure: '',
  regionalSpecification: '',
  pricePerOz: '',
  typeOfPackage: '',
  shelfLife: '',
  expectedLaunchMonth: null,
  productSize: '',
  casePack: '',
  label: '',
  ifBrandedWhy: '',
  attributes: '',
  preparationMethod: '',
  logistics: '',
  images: ["https://picsum.photos/300/200", "https://picsum.photos/300/200", "https://picsum.photos/300/200", "https://picsum.photos/300/200", "https://picsum.photos/300/200"],
  panelSheetDocument: '',
  nutritionFactPanel: '',
  voteResultsMonroviaRevision1: '',
  monroviaTastingPanelNotesRevision1: '',
  voteResultsMonrovia: '',
  monroviaTastingPanelNotes: '',
};

export const DefaultRequiredDocumentData: IRequiredDocumentData = {
  filename: "",
  type: "",
  data: "",
}

export const DefaultMVADocumentResponse: IMVADocumentResponse = {
  vendorId: 0,
  assessmentId: 0,
  mvaTemplateAvailable: "",
  mvaLatest: null,
  mvaReUpload: null,
  mvaHistory: null,
  mvatjLatest: null,
  mvatjHistory: null,
  availableTransitions: {
    data: []
  }
}

// For auto fill purpose

// export const VendorAssessmentFormData: IVendorAssessmentFormData = {
//   vendorName: "vendor 1",
//   productDeveloper: "pd",
//   productName: "PN",
//   typeOfVendor: "Taryn Wadas",
//   addedOn: format(startOfDay(new Date()), 'yyyy-MM-dd'),
//   currentlyManufactureSameSimilarProduct: "yes",
//   mostSimilarProduct: "similar product",
//   experienceWithSimilarType: "yes",
//   countryOfOrigin: "United States",
//   prop65Warning: "yes",
//   acceptableIngredients: "Acceptabl ingredient",
//   privateLabelFosUsCompanies: "yes",
//   capacityProductionRun: "10",
//   capacityProductionLines: "30",
//   capacityFacilities: "capacity facilities",
//   outsourceProduction: "yes",
//   sameTypeOfProductUnderConsideration: "yes",
//   facilityGfsiCertified: "yes",
//   certificationWithdrawnWithinLast5Years: "yes",
//   testFinishedProductsForPathogens: "yes",
//   metalDetectionXrayOnProductLine: "yes",
//   haccpFspPlan: "yes",
//   allergenManagementProgram: "management program",
//   productRecallProcedure: "product recall procedure",
//   recallWithinLast5Years: "yes",
//   recallDetail: "recall details",
//   facilityFdaUsdaInspected: "yes",
//   usdaPlantNo: "20",
//   regulatoryEnforcementAction: "yes",
//   adulteratedProductPoliciesProcedures: "adulterated product",
//   importAutomaticDetention: "yes",
//   outsourceDescripton: "outsource description",
//   factor: "factor",
//   childLaborVendor: "yes",
//   animalWelfareFraud: "yes",
//   fsmaCompliant: "yes",
//   edi850And860: "yes",
// }  // NOSONAR

export const VendorContactInformationFormData: IVendorContactInformationFormData = {
  vendorName: "",
  corporateZip: "",
  corporateAddress: "",
  corporateCity: "",
  corporateState: "",
  corporateCountry: "",
  contactFor: "",
  contactPersonEmailId: "",
  contactPersonPhone: "",
}
// MainDetails form data has been moved to @/static/initial/MainDetails
// IVendorFacilityInformation type has been moved to @/types/MainDetails.types


export const DefaultManufacturingFacilityInformationFormData: IManufacturingFacilityInformationFormData = {
  name: "",
  contact: "",
  emailId: "",
  phone: "",
  manufacturerZip: "",
  manufacturerAddress: "",
  manufacturerCity: "",
  manufacturerState: "",
  manufacturerCountry: "",
  newOrExistingSite: "new",
}

export const DefaultManufacturingFacilityInformationFormsData: IManufacturingFacilityInformationFormData[] = [
  { ...DefaultManufacturingFacilityInformationFormData },
];

// export const IngredientDetailsFormData: IIngredientDetailsFormData = {
//   vendorName: "vendor name",
//   ingredientList: [ "cheese", "cake" ],
//   subIngredientList: "",
//   unacceptableIngredients: "",
//   acceptableIngredients: "",
//   ingredientNotFoundList: "",
//   ingredientCompliance: "",
//   Comments: "",
// }

export const CertificatesDocumentsVendorInfoFormData: ICertificatesDocumentsVendorInfoFormData = {
  firstName: "",
  lastName: "",
  emailID: "",
  productAssociation: "",
  vendorRole: "",
  vendorGroup: "",
  artworkDeadlineDate: new Date()
}

export const addNewVendorUserData: IAddNewVendorUserData = {
  firstName: "",
  lastName: "",
  emailID: "",
  vendorRole: "",
  sites: "",
  vendorContact: "",
}

export const vendorPrePanelInformationFormData: VendorPrePanelInformationFormData = {
  productName: "",
  description: "",
  requiredAttributes: [],
  reasonForDevelopment: "",
  diversificationSku: "",
  statusNotes: "",
  estWeeklySales: undefined,
  estWeeklyUnitVol: undefined,
  categoryManager: "",
  developer: "",
  launchDate: new Date(),
  retailPrice: undefined,
  skuNumber: undefined,
  vendorName: "",
  vendorContactInfo: "",
  size: "",
  packSize: undefined,
  containerQuantity: undefined,
  businessCategory: "",
  productType: "",
  sellingPeriod: "",
  productSpecificationType: "",
  categoryManagerUserId: "",
  opportunityBuy: "",
  stockUnit: "",
  invoiceUnit: "",
};

// export const vendorBasicInformationFormData: VendorBasicInformationFormData = {
//   vendorName: "",
//   contactName: "",
//   phone: "",
//   jobTitle: "",
//   language: "",
//   country: "",
//   addressLineOne: "",
//   addressLineTwo: "",
//   city: "",
//   stateRegionProvince: "",
//   zipCodePostalCode: "",
//   userType: "",
//   userRoles: "",
//   isVendorContact: false,
//   vendorContactRoles: "",
//   isSiteContact: "",
//   sites: ""
// };

export const foodSafetyQuestionnaireFormData: FoodSafetyQuestionnaireFormData = {
  questions: {},
  requiredDocs: []
};

export const VendorSetupFormData: IVendorSetupFormData = {
  vendorDescription: "",
  vendorAddress1: "",
  vendorZipCode: "",
  vendorCity: "",
  vendorState: "",
  vendorCountry: "",
  vendorNumber: "",
  // Additional fields from API response
  vendorFirstName: "",
  vendorLastName: "",
  vendorEmailAddress: "",
  goldId: null,
  goldVendorName: null,
  vendorProductQueueChampionEmail: null,
  vendorProductQueueChampionName: null,
  vendorType: null,
  tariff: "",
  retailStructure: "",
  logistics: "",
  smallBusiness: false,
  // Vendor Assessment fields
  productDeveloper: "",
  productName: "",
  tjsContact: "",
  typeOfVendor: "",
  addedOn: "",
  currentlyManufactureSameSimilarProduct: "",
  mostSimilarProduct: "",
  experienceWithSimilarType: "",
  countryOfOrigin: "",
  prop65Warning: "",
  acceptableIngredients: "",
  privateLabelFosUsCompanies: "",
  capacityProductionRun: "",
  capacityAvailableCapacity: "",
  capacityProductionLines: "",
  capacityFacilities: "",
  outsourceProduction: "",
  sameTypeOfProductUnderConsideration: "",
  facilityGfsiCertified: "",
  auditScheme: null,
  certificationWithdrawnWithinLast5Years: "",
  haccpFspPlan: "",
  testFinishedProductsForPathogens: "",
  metalDetectionXrayOnProductLine: "",
  otherMetalDetectionXrayOnProductLine: "",
  allergenManagementProgram: "",
  productRecallProcedure: "",
  recallWithinLast5Years: "",
  recallDetail: "",
  facilityFdaUsdaInspected: "",
  usdaPlantNo: "",
  regulatoryEnforcementAction: "",
  adulteratedProductPoliciesProcedures: "",
  importAutomaticDetention: "",
  outsourceDescripton: "",
  factor: "",
  childLaborVendor: "",
  animalWelfareFraud: "",
  note: null,
  cost: null,
  freightCost: null,
  userId: "",
  fsma: "",
  edi: "",
  typeOfPackage: null,
  shelfLife: null,
  proposedRetail: "",
  businessStatus: "",
  workflowStatus: [],
}

export const officialProductSetupFormData: IOfficialProductSetupFormData = {
  sku: "",
  skuDescription: "",
  itemType: "",
  stockUnit: "",
  invoiceUnit: "",
  buyer: "",
  categoryHierarchy: "",
}

export const defaultVendorStatusesObj: vendorStatusesObj = {
  0: {
    status: "Not_Started",
    workflowStatus: [""],
  }
}
export const defaultTastigPanelVendorStatusObj: TastingPanelVendorStatusesObj = {
  0: {
    status: "awaiting_business_review",
    workflowStatus: [""],
  }
}
//mock data type for add new vendor user
export const DefaultAddNewVendorFormData: IVendorUser = {
  vendorFirstName: "",
  vendorLastName: "",
  vendorEmailAddress: "",
  vendorRoleName: "",
  vendorGroupName: "",
}
export const DefaultAddNewVendorFormsData: IVendorUser[] = [
  { ...DefaultAddNewVendorFormData },
];
export const InitialAddNewVendorFormsData: IVendorUser[] = [
  { temporaryId: "0", ...DefaultAddNewVendorFormData },
];

export const defaultSendWelcomeEmailFormData: ISendWelcomeEmailFormData = {
  htmlContent: "",
  vendorId: "",
  vendorUserId: undefined,
  vendorAssessmentId: "",
  transitionsRequest: {
    transitionId: "",
    objectId: "",
    portalUserId: "",
    createTask: false
  }
}

export const DefaultVendorSiteDetailsFormData: VendorSiteDetailsFormData = {
  // Display-only fields (read-only in UI). For new sites / missing API values, show "N/A".
  orbcSiteCode: "N/A",
  productPortalSiteId: "N/A",
  newOrExistingSite: "new",
  siteName: "",
  siteAddress: "",
  siteCity: "",
  siteStateRegionProvince: "",
  siteZipPostalCode: "",
  siteCountry: "",
  siteType: [],
  businessCategory: "",
  siteStatus: "",
  gfsiCertified: "",
  organicCertified: "",
  vendorContact: "",
  remarksFromUser: "",
  skuNumber: "",
}

export const DefaultVendorSiteDetailsFormsData: VendorSiteDetailsFormData[] = [
  { ...DefaultVendorSiteDetailsFormData },
];

 



export const vendorSitesFormData: IVendorSiteDetailsFormData = {
  productPortalId: "",
  siteCode: "",
  siteName: "",
  siteCountry: "",
  siteAddress: "",
  siteCity: "",
  siteState: "",
  siteZip: "",
  siteType: [],
  businessCategories: "",
  siteStatus: "",
  gfsiCertified: "",
  organicCertified: "",
  vendorContact: "",
  remarksFromUser: "",
  sku: "",
}

export const VendorAuditDetailsFormData: IVendorAuditDetailsFormData = {
  siteName: "",
  auditStatus: "",
  certificationExpirationDate: new Date(),
  auditDueDate: new Date(),
  auditScore: "",
  auditStartDate: new Date(),
  auditFinishDate: new Date(),
  auditTemplate: "",
  personResponsible: "",
  regulatoryGovernance: "",
  summary: ""
}

export const DefaultVendorContactData: VendorContactData = {
  contactName: "",
  contactPersonPhone: "",
  contactPersonEmailId: "",
  country: "",
  addressLineOne: "",
  addressLineTwo: "",
  city: "",
  state: "",
  zip: "",
  userId: "",
  vendorContactGroups: [{ id: "0" }],
  vendor: { id: "0" },
  site: [{ id: "0" }]
}
